import React, { ReactElement } from 'react';
import ActionButton from '../action-button/action-button.component';
import MenuIcon from '../../icons/menu-icon';
import useStylesNavigationMenuButton from './navigation-menu-button.styles';

const NavigationMenuButton: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COLOR_INHERIT: ThemeColor = 'inherit';

  const {
    onClick,
  } = props;

  const { classes } = useStylesNavigationMenuButton();

  return (
    <ActionButton className={classes.navigationMenuButton} color={COLOR_INHERIT} onClick={onClick}>
      <MenuIcon />
    </ActionButton>
  );
});

export default NavigationMenuButton;
